export default __webpack_public_path__ + "static/media/blog-img220.08f075a4.jpg";